import { Stack } from '@mui/material';
import { styled } from '@mui/system';
import BoxButton from '@/components/@IntranetLibrary/Button/BoxButton';

export const TextFieldWrappers = styled(Stack)`
  padding: 24px 12px;
  gap: 8px;
`;

export const ListWrapper = styled(Stack)`
  flex: 1;
  overflow-y: auto;
`;

export const ListTitleWrapper = styled(Stack)`
  padding: 12px;
  align-items: center;
  gap: 8px;
  border-top: 1px solid var(--dk-line, #e7e9ec);
  border-bottom: 1px solid var(--dk-line, #e7e9ec);
`;

/** 가이드에 없는 32px 단계 — 이 패널 전용 베리에이션 */
export const CompactReplaceButton = styled(BoxButton)`
  height: 32px;
  min-width: auto;
  padding: 0 8px;
  font-size: 12px;
  border-radius: 6px;
`;
